/**
 * Конверт ответа бэкенда (ADR-002) — ЕДИНСТВЕННОЕ место распаковки на фронте.
 *
 * Глобальный `ResponseInterceptor` бэкенда (`src/shared/interceptors/response.interceptor.ts`,
 * зарегистрирован как `APP_INTERCEPTOR` в `app.module.ts`) оборачивает КАЖДЫЙ непустой
 * ответ в `{ success, data, meta }` — включая голые массивы и включая ответы, которые
 * контроллер уже обернул руками (легаси-ветка интерцептора пропускает такой объект как
 * есть и лишь дописывает `meta`). Исключения ровно два: `StreamableFile` (ADR-010) и
 * пустое тело 204.
 *
 * Отсюда правило для любого клиента поверх ГОЛОГО axios-инстанса (`./api`): полезная
 * нагрузка лежит на ДВА уровня глубже отклика — `response.data.data`, а не
 * `response.data`. Дженерик axios ничего не проверяет: `api.get<T>(url)` объявляет
 * `AxiosResponse<T>`, но кладёт в `.data` конверт, поэтому `tsc` на ошибке молчит,
 * а экран получает объект с полем `data` вместо ожидаемых полей.
 *
 * Класс уже стоил проекту одной находки: P-3 (`api-keys.api.ts` возвращал сам конверт
 * под типом `ApiKeyListItem[]`, страница падала на `keys.map is not a function`).
 * Главный урок той находки записан в реестре: компонентный тест с моком, отдающим уже
 * распакованные данные, красным НЕ станет. Поэтому мок в тесте обязан повторять
 * ПРОВОДНУЮ форму — конверт.
 *
 * Клиенты поверх класса `HttpClient` (`src/services/http-client.ts`) этой распаковки
 * НЕ требуют: его `get<T>` сам возвращает `response.data`, то есть уже конверт
 * `ApiResponse<T>`, и его потребители читают `.data` один раз.
 */
export interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

/**
 * Достаёт полезную нагрузку из конверта. Нарушение контракта — это ошибка,
 * а не повод отрисовать пустой экран: молчаливый фолбэк спрятал бы поломку
 * бэкенда ровно так же, как её прятал прежний код.
 */
export function unwrap<T>(
  body: ApiEnvelope<T> | undefined,
  endpoint: string,
): T {
  if (!body || typeof body !== "object" || !("data" in body)) {
    throw new Error(
      `Ответ ${endpoint} не соответствует контракту ADR-002: нет поля data`,
    );
  }
  return body.data;
}
